import { isEqual } from './is-equal';
import { cloneDeep } from '@fi-shared/utils/clone-deep';

export class FiValuesComparison<T> {
    private readonly getValueFn: () => T;
    private readonly _originalObj: T;

    constructor(getValueFn: () => T) {
        this.getValueFn = getValueFn;
        this._originalObj = cloneDeep(getValueFn());
    }

    isChanged(): boolean {
        return !isEqual(this._originalObj, this.getValueFn());
    }
}
